import {Link} from 'react-router-dom';
import { useAppSelector, useAppDispatch } from 'hooks';

// material-ui
import {ButtonBase} from '@mui/material';

// project imports
import config from 'config';
import Logo from 'ui-components/Logo';
import { openMenu } from 'store/customizationReducer';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
    const customization = useAppSelector((state) => state.customization);
    const { defaultId } = customization;
    const dispatch = useAppDispatch();
    return (
        <ButtonBase disableRipple onClick={() => dispatch(openMenu(defaultId))} component={Link}
                    to={config.defaultPath}>
            <Logo/>
        </ButtonBase>
    );
};

export default LogoSection;
